/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const putPipeSeriesPipeseriesidPipesPipeidPathPipeSeriesIdSchema = z.string()

export const putPipeSeriesPipeseriesidPipesPipeidPathPipeIdSchema = z.string()

export const putPipeSeriesPipeseriesidPipesPipeidStatus200Schema = z.object({
  internalDiameter: z.number().describe('The internal diameter of the pipe in millimeters').meta({ examples: [100] }),
  maxPressure: z.number().describe('The maximum pressure the pipe can withstand in bar').meta({ examples: [10] }),
  maxTemperature: z.number().describe('The maximum temperature the pipe can withstand in Celsius').meta({ examples: [120] }),
  name: z.string().describe('The name of the pipe').meta({ examples: ['Pipe 1'] }),
  roughness: z.number().describe('The roughness of the pipe in micrometers').meta({ examples: [50] }),
  valveSize: z.string().describe('The size of the valve associated with the pipe').meta({ examples: ['DN_10'] }),
  id: z.string().describe('Unique identifier').meta({ examples: [1] }),
})

export const putPipeSeriesPipeseriesidPipesPipeidStatus400Schema = z.string()

export const putPipeSeriesPipeseriesidPipesPipeidStatus401Schema = z.string()

export const putPipeSeriesPipeseriesidPipesPipeidStatus404Schema = z.string()

export const putPipeSeriesPipeseriesidPipesPipeidStatus500Schema = z.string()

export const putPipeSeriesPipeseriesidPipesPipeidResponseSchema = putPipeSeriesPipeseriesidPipesPipeidStatus200Schema

export const putPipeSeriesPipeseriesidPipesPipeidErrorSchema = z.union([putPipeSeriesPipeseriesidPipesPipeidStatus400Schema, putPipeSeriesPipeseriesidPipesPipeidStatus401Schema, putPipeSeriesPipeseriesidPipesPipeidStatus404Schema, putPipeSeriesPipeseriesidPipesPipeidStatus500Schema])

export const putPipeSeriesPipeseriesidPipesPipeidBodySchema = z.object({
  internalDiameter: z.number().describe('The internal diameter of the pipe in millimeters').meta({ examples: [100] }),
  maxPressure: z.number().describe('The maximum pressure the pipe can withstand in bar').meta({ examples: [10] }),
  maxTemperature: z.number().describe('The maximum temperature the pipe can withstand in Celsius').meta({ examples: [120] }),
  name: z.string().describe('The name of the pipe').meta({ examples: ['Pipe 1'] }),
  roughness: z.number().describe('The roughness of the pipe in micrometers').meta({ examples: [50] }),
  valveSize: z.string().describe('The size of the valve associated with the pipe').meta({ examples: ['DN_10'] }),
}).optional()
